// Section links. Pinned sections need a computed target, because a plain anchor jump
// would land at the start of a long pinned wrapper instead of the moment the content shows.

const TOP_BAR_OFFSET = 72

const prefersReducedMotion = (): boolean => window.matchMedia('(prefers-reduced-motion: reduce)').matches

const isImmersive = (): boolean => document.documentElement.dataset.motion !== 'static'

export const scrollToY = (top: number, instant = false): void => {
    window.scrollTo({
        top: Math.max(0, top),
        behavior: instant || prefersReducedMotion() ? 'auto' : 'smooth'
    })
}

export const pinnedTarget = (host: HTMLElement, progress: number): number => {
    const top = host.getBoundingClientRect().top + window.scrollY
    const travel = Math.max(0, host.offsetHeight - window.innerHeight)

    return top + travel * progress
}

// The scroll position where a section "starts" for links and for the active nav marker.
export const sectionAnchorY = (id: string): number | null => {
    if (id === 'top') return 0

    const element = document.getElementById(id)
    if (!element) return null

    const hostId = element.dataset.pinHost
    const host = hostId ? document.getElementById(hostId) : null

    if (host && isImmersive()) return pinnedTarget(host, Number(element.dataset.pinProgress ?? '0'))
    if (element.dataset.pinWrapper === 'true' && isImmersive()) return element.getBoundingClientRect().top + window.scrollY

    return element.getBoundingClientRect().top + window.scrollY - TOP_BAR_OFFSET
}

export const scrollToSection = (id: string, options: { instant?: boolean, updateHash?: boolean } = {}): void => {
    const target = sectionAnchorY(id)
    if (target === null) return

    scrollToY(target, options.instant)

    if (options.updateHash === false) return

    if (id === 'top') window.history.replaceState(null, '', window.location.pathname + window.location.search)
    else window.history.replaceState(null, '', `#${id}`)
}
